import { render } from "./Header.vue?vue&type=template&id=21772a14&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=21772a14&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../worktrees/adel01/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21772a14"]])

export default __exports__